module.exports = __webpack_public_path__ + "img/blue_113.1bf4d247.png";